import { jwtDecode } from 'jwt-decode';
import { authActions } from '../auth/slice';
import { AppDispatch } from '../../store';
import { JWToken } from './types';

export const API_URL = import.meta.env.VITE_JUSTWORDS_API_URL;

export class LoginError extends Error { };
export class TokenRefreshError extends Error { };
export class SignupError extends Error { };

export const logIn = async (email: string, password: string, dispatch: AppDispatch) => {
  const result = await post(
    `${API_URL}/token`,
    { email, password }
  );
  const body = await result.json();

  if (result.ok) {
    const decoded = jwtDecode<JWToken>(body.access);
    dispatch(authActions.setAccessToken(body.access));
    if (decoded.exp) {
      dispatch(authActions.setAccessTokenExpiry(decoded.exp));
    }
    dispatch(authActions.setRefreshToken(body.refresh));
  }
  else {
    throw new LoginError(body.detail);
  }

};

export const refreshAuthToken = async (refreshToken: string): Promise<string> => {
  const result = await post(
    `${API_URL}/token/refresh`,
    {
      refresh: refreshToken
    }
  );
  if (result.ok) {
    const json = await result.json();
    return json.access;
  }
  throw new TokenRefreshError(result.statusText);
};

export const signUp = async (email: string, password: string, passwordConfirm: string, dispatch: AppDispatch) => {
  if (password !== passwordConfirm) {
    throw new SignupError("The provided passwords did not match.");
  }

  const result = await post(
    `${API_URL}/../../auth/registration/`,
    {
      email,
      password1: password,
      password2: passwordConfirm
    }
  );

  const body = await result.json();

  if (result.ok) {
    dispatch(authActions.setAccessToken(body.access));
    dispatch(authActions.setRefreshToken(body.refresh));
    return body.access;
  }
  throw new SignupError(Object.values(body).join('; '));
};

const post = (url: string, body: object) => fetch(
  url,
  {
    method: 'post',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    }
  }
);
